export default "__VITE_ASSET__DMSyPBdb__"